export const filtersData = [
  { name: 'Wszystkie', id: 'all' },
  { name: 'Niezrealizowane', id: 'active' },
  { name: 'Zrealizowane', id: 'used' },
  { name: 'Nieaktywne', id: 'inactive' }
]
